import type { BorderRadiusLonghand } from '../../utils/borderRadius';

export const Decoline = ({ borderRadius }: { borderRadius?: BorderRadiusLonghand }) => (
  <span
    className="pointer-events-none absolute top-0 left-0 flex h-full w-full overflow-hidden"
    style={borderRadius}
  >
    <span className="bg-color-primary h-[0.1875rem] w-full" />
  </span>
);
